module.exports = __webpack_public_path__ + "static/assets/d92faa93ec9d77baa6d7dc2ca6652996.gif";